import { IEntity } from "./Entity";
import { IPPAppProjectUpdateFinancial } from "./PPAppProjectUpdateFinancial";
import { IProject } from "./Project";
import { IRagOption } from "./RagOption";
import { IReportingProgressUpdate, ReportingProgressUpdate } from "./ReportingProgressUpdate";

export interface IProjectUpdate extends IReportingProgressUpdate {
    ProjectID: number | null;
    OverallRagOptionID: number | null;
    FinanceRagOptionID: number | null;
    FinanceComment: string;
    PeopleRagOptionID: number | null;
    PeopleComment: string;
    MilestonesRagOptionID: number | null;
    MilestonesComment: string;
    BenefitsRagOptionID: number | null;
    BenefitsComment: string;
    ProgressUpdate: string;
    FutureActions: string;
    Escalations: string;

    ProjectPhaseID: number | null;
    BusinessCaseTypeID: number | null;
    BusinessCaseDate: Date | null;
    WholeLifeCost: number | string;
    WholeLifeBenefit: number | string;
    NetPresentValue: number | string;

    StartDate: Date | null;
    EndDate: Date | null;

    Project?: IProject | null;
    ProjectPhase?: IEntity;
    BusinessCaseType?: IEntity;
    OverallRagOption?: IRagOption;
    FinanceRagOption?: IRagOption;
    PeopleRagOption?: IRagOption;
    MilestonesRagOption?: IRagOption;
    BenefitsRagOption?: IRagOption;

    PPAppProjectUpdateFinancials?: IPPAppProjectUpdateFinancial[];
}

export class ProjectUpdate extends ReportingProgressUpdate implements IProjectUpdate {
    public ProjectID: number | null = null;
    public OverallRagOptionID = null;
    public FinanceRagOptionID = null;
    public FinanceComment = '';
    public PeopleRagOptionID = null;
    public PeopleComment = '';
    public MilestonesRagOptionID = null;
    public MilestonesComment = '';
    public BenefitsRagOptionID = null;
    public BenefitsComment = '';
    public ProgressUpdate = '';
    public FutureActions = '';
    public Escalations = '';

    public ProjectPhaseID = null;
    public BusinessCaseTypeID = null;
    public BusinessCaseDate = null;
    public WholeLifeCost = '';
    public WholeLifeBenefit = '';
    public NetPresentValue = '';

    public StartDate = null;
    public EndDate = null;

    public UpdateUser = null;
    public Project: IProject | null = null;

    constructor(projectId?: number, period?: Date) {
        super(period);
        if (projectId)
            this.ProjectID = projectId;
    }
}